var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FrMyAccessReviewTable',{attrs:{"default-sort":"application.name","fields":_vm.fields,"grant-type":"account"}})
}
var staticRenderFns = []

export { render, staticRenderFns }